import React from "react";
import { IoMdTime } from "react-icons/io";
import { IoLocationOutline } from "react-icons/io5";
import header from "../assets/header.webp";
import logo from "../assets/logo.webp";
import instagram from "../assets/instagram.webp";
import facebook from "../assets/facebook.webp";

export default function Header() {
  return (
    <div>
      <div
        style={{
          backgroundImage: `url(${header})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "22vh",
          display: "flex",
          justifyContent: "center",
          position: "relative",
          zIndex: "-1",
        }}
      >
        <img
          src={logo}
          alt="logo"
          style={{
            borderRadius: "150px",
            height: "70px",
            width: "70px",
            marginTop: "8vh",
          }}
        />
      </div>
      <div
        style={{
          borderRadius: "30px 30px 0px 0px ",
          marginTop: "-3.7rem",
          backgroundColor: "white",
        }}
      >
        <p
          style={{
            color: "#535353",
            fontSize: "2rem",
            fontWeight: "bold",
            padding: "20px 0px 0px 20px",
            marginBottom: "10px",
          }}
        >
          Cafe 34
        </p>
        <p
          style={{
            color: "#535353",
            paddingLeft: "20px",
            fontSize: "1.5rem",
            fontWeight: "bold",
            marginTop: "0",
          }}
        >
          Cafe 34
        </p>

        {/* Container for opening hours */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginLeft: "20px",
            marginTop: "10px",
          }}
        >
          <IoMdTime style={{ fontSize: "1rem", marginRight: "8px" }} />
          <p
            style={{
              color: "#535353",
              fontSize: "1rem",
              margin: 0,
            }}
          >
            09:00 - 02:00
          </p>
        </div>

        {/* Container for location with clickable link */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginLeft: "20px",
            marginTop: "5px",
          }}
        >
          <IoLocationOutline style={{ fontSize: "1rem", marginRight: "8px" }} />
          <a
            href="https://maps.app.goo.gl/wQhozkuXM1WkriBU8"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#535353",
              fontSize: "1rem",
              margin: 0,
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            Kyrenia Harbour, Kyrenia, Cyprus
          </a>
        </div>
      </div>

      {/* Social Media Icons with clickable links */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          padding: "20px",
          marginTop: "10px",
        }}
      >
        <a
          href="https://www.facebook.com/cafe34/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={facebook}
            alt="facebook"
            style={{
              height: "3vh",
              width: "3vh",
              marginRight: "10px",
              cursor: "pointer",
            }}
          />
        </a>
        <a
          href="https://www.instagram.com/cafe34/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={instagram}
            alt="instagram"
            style={{
              height: "3vh",
              width: "3vh",
              cursor: "pointer",
            }}
          />
        </a>
      </div>
    </div>
  );
}
